import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";

//  Main Pages
import Index from "./views/Index.vue";

//  Main Examples
import Login from "./views/Login.vue";
import Profile from "./views/Profile.vue";
import ForgotPassword from "./views/ForgotPassword.vue";
import FindEngineer from "./views/FindEngineer.vue";
import Engineer from "./views/Engineer.vue";
import JoinAer from "./views/JoinAer.vue";
import AboutUs from "./views/AboutUs.vue";
import ContactUs from "./views/ContactUs.vue";
import Privacy from "./views/Privacy.vue";

import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "home",
            components: { default: Index, header: MainNavbar, footer: MainFooter },
            props: {
                header: { colorOnScroll: 400, navbarTransparent: true }
            }
        },
        {
            path: "/privacy-policy",
            name: "privacy",
            components: { default: Privacy, header: MainNavbar, footer: MainFooter },
            props: {
                header: { colorOnScroll: 200, navbarTransparent: true }
            }
        },
        {
            path: "/find-engineer",
            name: "find-engineer",
            components: { default: FindEngineer, header: MainNavbar, footer: MainFooter },
            props: {
                header: { colorOnScroll: 400, navbarTransparent: true }
            }
        },
        {
            path: "/@:id",
            name: "engineer.profile",
            components: { default: Engineer, header: MainNavbar, footer: MainFooter },
            props: {
                header: { colorOnScroll: 400, navbarTransparent: true }
            }
        },
        {
            path: "/engineer",
            name: "engineer",
            components: { default: Engineer, header: MainNavbar, footer: MainFooter },
            props: {
                header: { colorOnScroll: 400, navbarTransparent: true }
            }
        },
        {
            path: "/join",
            name: "join",
            components: { default: JoinAer, header: MainNavbar, footer: MainFooter },
            props: {
                header: { colorOnScroll: 200, navbarTransparent: true }
            }
        },
        {
            path: "/about",
            name: "about",
            components: { default: AboutUs, header: MainNavbar, footer: MainFooter },
            props: {
                header: { colorOnScroll: 400, navbarTransparent: true }
            }
        },
        {
            path: "/contact",
            name: "contact",
            components: {
                default: ContactUs,
                header: MainNavbar,
                footer: MainFooter
            },
            props: {
                header: { colorOnScroll: 0, navbarTransparent: false, type: "dark" }
            }
        },
        {
            path: "/login",
            name: "login",
            components: { default: Login, header: MainNavbar, footer: MainFooter },
            props: {
                header: { colorOnScroll: 400, navbarTransparent: true }
            },
            meta: {
                guestOnly: true
            }
        },
        {
            path: "/forgot-password",
            name: "forgot-password",
            components: { default: ForgotPassword, header: MainNavbar, footer: MainFooter },
            props: {
                header: { colorOnScroll: 400, navbarTransparent: true }
            },
            meta: {
                guestOnly: true
            }
        },
        {
            path: "/profile",
            name: "profile",
            components: { default: Profile, header: MainNavbar, footer: MainFooter },
            props: {
                header: { colorOnScroll: 70, navbarTransparent: true, loggedIn: true },
            },
            meta: {
                requiresAuth: true
            }
        }
    ],
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    }
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters.isLoggedIn) {
            next({ name: 'login' })
        } else {
            next() 
        }
    } 

    if (to.matched.some(record => record.meta.guestOnly)) {
        if (store.getters["isLoggedIn"]) {
            next({ name: 'profile' })
        } else {
            next()
        }
    }

    next() 
})

export default router;